//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import checkNumber from '../common/checkNumber.vue'
export default {
    components: {
        checkNumber
    },
    data() {
        return {
            popupShow: false,
            selectColor: '1',
            number: 1,
            type: 1,
            goods: {},
            submitFlag: true, //提交按钮节流
        }
    },
    methods: {
        //1加入购物车，2立即购买
        openPopup(goods, type = 1) {
            this.type = type;
            this.goods = goods;
            this.popupShow = true;
        },
        closePopup() {
            this.selectColor = '1';
            this.number = 1;
            this.type = 1;
            this.goods = {};
        },
        //节流
        buttonFlag(code) {
            if(!this[code]) {
                this.$vux.toast.text('请不要快速点击');
                return false;
            } else {
                this[code] = false;
                setTimeout(() => {
                    this[code] = true;
                }, 1500);
                return true;
            }
        },
        submit() {
            if(!this.buttonFlag('submitFlag')) {
                return false;
            }
            if(this.type == 1) {
                let that = this;
                let orderCart = {
                    goodsId: that.goods.goodsId,
                    goodsAttributeId: that.goods.goodsAttributeId,
                    number: that.number
                }
                let data = {
                    orderCart: JSON.stringify(orderCart),
                    shopperId: that.$store.state.userInfo.shopperId
                }
                that.$axios.post('/api/v1.0/lonbonShop/saveOrderCart', that.qs.stringify(data)).then(function (response) {
                    if(response.status == 200) {
                        that.$vux.toast.show({
                            text: '已加入购物车',
                            type: 'success'
                        })
                        that.popupShow = false;
                        that.$store.state.APPPAGE.getOrderCartNum();
                    }
                })
            } else {
                this.goods.number = this.number;
                sessionStorage.readyBuyGoods = JSON.stringify([this.goods]);
                this.$router.push("/goBuy");
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/buycar/add.vue